import { ForwardedRef, forwardRef } from 'react'

import cx from 'classnames'

import { MissionLocationIcon } from '@local/assets/icons'
import { CLICK_CODE } from '@local/utils'

import Image from '@web/components/Image'
import { usePropsViewerMode } from '@web/libs/dev/MyplaceDevtools/usePropsViewer'
import { Nullish } from '@web/types'
import Clickable from '@web/ui/components/Clickable'

import styles from '../MissionSection.module.scss'
import NewProgressCircle from './NewProgressCircle'
interface MissionCardItemIconProps {
  label?: string
  imageUrl?: Nullish<string>
  borderImageUrl?: Nullish<string>
}
function MissionCardItemIcon(props: MissionCardItemIconProps) {
  const { imageUrl, borderImageUrl } = props

  // 프로필 띠 타입
  if (borderImageUrl && imageUrl) {
    return (
      <div className={styles.icon_area}>
        {/* TODO: 서버에서 기본 프로필 imageUrl 보내줘야겠다 */}
        <Image className={styles.profile} src={imageUrl} width={26} height={26} alt="프로필" />
        <Image className={styles.border} src={borderImageUrl} width={32} height={32} alt="프로필 띠" />
      </div>
    )
  }

  // 기본 타입 : 미션 시작 전 또는 이미지가 없을 경우 기본 아이콘
  if (!imageUrl) {
    return (
      <div className={styles.icon_area}>
        <MissionLocationIcon className={styles.icon_location} aria-hidden="true" />
      </div>
    )
  }

  return (
    <div className={styles.icon_area}>
      <Image className={styles.img} src={imageUrl} width={26} height={26} alt="이미지" />
    </div>
  )
}

interface Props {
  name: string
  isOver?: boolean
  isInfiniteMission?: boolean
  isBeforeStart: boolean
  progressCount: number
  totalCount?: Nullish<number>
  imageUrl?: Nullish<string>
  borderImageUrl?: Nullish<string>
  stampName: string
  url?: string
  isParticipating: boolean
  idx?: number
}
function MissionCardItem(props: Props, ref: ForwardedRef<HTMLLIElement>) {
  const {
    name,
    isOver,
    isInfiniteMission,
    isBeforeStart,
    progressCount,
    totalCount,
    stampName,
    url,
    isParticipating,
    idx,
  } = props

  const { PropsViewer } = usePropsViewerMode({ props })

  if (PropsViewer) return <li ref={ref}>{PropsViewer}</li>

  return (
    <li className={styles.list_item} ref={ref}>
      <Clickable
        className={styles.list_item_link}
        href={url}
        nClickCode={CLICK_CODE[isParticipating ? 'mymission.card' : 'mymission.emptycard']}
        nClickRank={idx ? idx + 1 : undefined}
      >
        <div
          className={cx(styles.circle_area, {
            [styles.type_not_in_progress]: isBeforeStart,
            [styles.type_over]: isOver,
          })}
        >
          <MissionCardItemIcon {...props} />
          <NewProgressCircle
            className={styles.circle}
            total={totalCount}
            count={progressCount}
            gradient={isInfiniteMission}
          />
        </div>
        <div className={styles.txt_area}>
          <div className={styles.tit_area}>{name}</div>
          <div
            className={cx(styles.count_area, {
              [styles.type_not_in_progress]: isBeforeStart,
              [styles.type_over]: isOver,
            })}
          >
            <span className={styles.tit}>{stampName}</span>
            {totalCount ? (
              <span className={styles.count}>
                <em>{progressCount}</em>/{totalCount}개
              </span>
            ) : (
              <span className={styles.count}>
                <em>{progressCount}개</em>
              </span>
            )}
          </div>
        </div>
      </Clickable>
    </li>
  )
}
export default forwardRef(MissionCardItem)
